<!--
  -    Copyright (c) 2018-2025, lengleng All rights reserved.
  -
  - Redistribution and use in source and binary forms, with or without
  - modification, are permitted provided that the following conditions are met:
  -
  - Redistributions of source code must retain the above copyright notice,
  - this list of conditions and the following disclaimer.
  - Redistributions in binary form must reproduce the above copyright
  - notice, this list of conditions and the following disclaimer in the
  - documentation and/or other materials provided with the distribution.
  - Neither the name of the pig4cloud.com developer nor the names of its
  - contributors may be used to endorse or promote products derived from
  - this software without specific prior written permission.
  - Author: lengleng (wangiegie@gmail.com)
  -->

<template>
	<div class="execution">
		<basic-container>
			<avue-crud
				ref="crud"
				:data="tableData"
				:option="tableOption"
				:page.sync="page"
				:table-loading="tableLoading"
				@on-load="getList"
				@refresh-change="refreshChange"
				@size-change="sizeChange"
				@current-change="currentChange"
				@search-change="searchChange"
				@row-update="handleUpdate"
				@row-save="handleSave"
				@row-del="rowDel">
				<template slot="menu" slot-scope="scope">
					<el-button
						v-if="permissions.daemon_status_trace_log_del"
						icon="el-icon-delete"
						type="text"
						@click="handleDel(scope.row, scope.index)">
						删除
					</el-button>
				</template>
			</avue-crud>
		</basic-container>
	</div>
</template>

<script>
import {addObj, delObj, fetchList, putObj} from '@/api/daemon/status-trace-log'
import {tableOption} from '@/const/crud/daemon/status-trace-log'
import {mapGetters} from 'vuex'

export default {
	name: 'StatusTraceLog',
	data() {
		return {
			searchForm: {},
			tableData: [],
			page: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 20, // 每页显示多少条
			},
			tableLoading: false,
			tableOption: tableOption,
		}
	},
	computed: {
		...mapGetters(['permissions']),
	},
	methods: {
		getList(page, params) {
			this.tableLoading = true
			fetchList(
				Object.assign(
					{
						current: page.currentPage,
						size: page.pageSize,
					},
					params,
					this.searchForm,
				),
			).then((response) => {
				this.tableData = response.data.data.records
				this.page.total = response.data.data.total
				this.tableLoading = false
			})
		},
		handleAdd: function () {
			this.$refs.crud.rowAdd()
		},
		handleEdit(row, index) {
			this.$refs.crud.rowEdit(row, index)
		},
		handleDel(row, index) {
			this.$refs.crud.rowDel(row, index)
		},
		rowDel: function (row, index) {
			this.$confirm('是否确认删除ID为' + row.id, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(function () {
					return delObj(row.clientId)
				})
				.then(() => {
					this.$message.success('删除成功')
					this.refreshChange()
				})
		},
		handleUpdate: function (row, index, done) {
			putObj(row).then(() => {
				this.$message.success('修改成功')
				this.refreshChange()
				done()
			})
		},
		handleSave: function (row, done) {
			addObj(row).then(() => {
				this.$message.success('添加成功')
				this.refreshChange()
				done()
			})
		},
		searchChange(form, done) {
			this.searchForm = form
			this.page.currentPage = 1
			this.getList(this.page, form)
			done()
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},
		currentChange(current) {
			this.page.currentPage = current
		},
		refreshChange() {
			this.getList(this.page)
		},
	},
}
</script>

<style lang="scss" scoped></style>
